import React, { useEffect, useMemo, useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';
import { v2_all_user } from '../../../actions/v2/user';

const getInitialAssignedUserIds = (data) => {
    const fallbackValues = data?.ASSIGNED_USER_IDS || data?.assignedUserIds || data?.assignedUsers || [];
    const assignedUsers = Array.isArray(data?.ASSIGNED_USERS) ? data.ASSIGNED_USERS : fallbackValues;

    if (Array.isArray(assignedUsers)) {
        return Array.from(
            new Set(
                assignedUsers
                    .map((item) => Number(item?.USER_ID || item))
                    .filter((value) => Number.isInteger(value) && value > 0)
                    .map((value) => String(value))
            )
        );
    }

    if (typeof assignedUsers === 'string') {
        return Array.from(
            new Set(
                assignedUsers
                    .split(',')
                    .map((value) => Number(String(value || '').trim()))
                    .filter((value) => Number.isInteger(value) && value > 0)
                    .map((value) => String(value))
            )
        );
    }

    return [];
};

const CategoryForm = ({ data, onSubmit, title }) => {
    const [state, setState] = useState({
        categoryName: { name: 'categoryName', value: data?.CATEGORY_NAME || '', isRequired: true, error: '' },
        description: { name: 'description', value: data?.DESCRIPTION || data?.NOTE || '', isRequired: false, error: '' },
        assignedUserIds: {
            name: 'assignedUserIds',
            value: getInitialAssignedUserIds(data),
            isRequired: false,
            error: ''
        },
    });
    const [users, setUsers] = useState([]);
    const [userSearch, setUserSearch] = useState('');

    useEffect(() => {
        v2_all_user().then((res) => {
            if (res?.status) {
                setUsers(res.result || []);
            }
        }).catch((error) => {
            console.error('Failed to fetch users:', error);
        });
    }, []);

    const filteredUsers = useMemo(() => {
        const query = userSearch.trim().toLowerCase();
        if (!query) return users;

        return users.filter((user) =>
            String(user.FULL_NAME || '')
                .toLowerCase()
                .includes(query)
        );
    }, [users, userSearch]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleToggleAssignedUser = (userId) => {
        const normalizedUserId = String(userId);
        setState((prevState) => {
            const selectedIds = Array.isArray(prevState.assignedUserIds.value) ? prevState.assignedUserIds.value : [];
            const updatedIds = selectedIds.includes(normalizedUserId)
                ? selectedIds.filter((value) => value !== normalizedUserId)
                : [...selectedIds, normalizedUserId];

            return {
                ...prevState,
                assignedUserIds: {
                    ...prevState.assignedUserIds,
                    value: updatedIds,
                },
            };
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };


    return (
        <form onSubmit={handleSubmit}>
            {/* <h4 className="card-title mb-4">{title}</h4> */}
            <div className="row">
                <div className="col-md-12 mb-3">
                    <label>Category Name {state.categoryName.isRequired && <span className='text-danger'> *</span>}</label>
                    <input
                        type="text"
                        name={state.categoryName.name}
                        value={state.categoryName.value}
                        onChange={handleChange}
                        placeholder="Enter category name"
                        className={`form-control ${state.categoryName.error ? 'is-invalid' : ''}`}
                    />
                    {state.categoryName.error && <div className="invalid-feedback">{state.categoryName.error}</div>}
                </div>


                <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                        name={state.description.name}
                        value={state.description.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="2"
                        placeholder="Any additional notes"
                    />
                </div>

                <div className="col-md-12 mb-3">
                    <label>Assign Users for Category Notifications</label>
                    <input
                        type="text"
                        className="form-control form-control-sm mb-2"
                        placeholder="Search users..."
                        value={userSearch}
                        onChange={(e) => setUserSearch(e.target.value)}
                    />
                    <div className="border rounded p-2" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                        {filteredUsers.length > 0 ? filteredUsers.map((user) => (
                            <div className="form-check" key={user.USER_ID}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`category-user-${user.USER_ID}`}
                                    checked={state.assignedUserIds.value.includes(String(user.USER_ID))}
                                    onChange={() => handleToggleAssignedUser(user.USER_ID)}
                                />
                                <label className="form-check-label" htmlFor={`category-user-${user.USER_ID}`}>
                                    {user.FULL_NAME}
                                    {user.ROLE_NAME ? ` (${user.ROLE_NAME})` : ''}
                                </label>
                            </div>
                        )) : (
                            <small className="text-muted">No users found.</small>
                        )}
                    </div>
                    <small className="text-muted">
                        {state.assignedUserIds.value.length} user{state.assignedUserIds.value.length === 1 ? '' : 's'} selected
                    </small>
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white" href={constant.Authedcomponent.listCategoryMasterData.url}>Cancel</a>
            </div>
        </form>
    );
};

export default CategoryForm;
